import stakewiz from "./images/powered-by-stakewiz-b.png";


function StakewizImage(){
    return <a href="https://stakewiz.com/" rel="noreferrer" target="_blank">
        <img alt="StakeWiz" src={stakewiz} height="20" />
        </a>
   }
   export default StakewizImage